import { Component, OnInit } from '@angular/core';
import { DropDownService } from 'src/app/service/drop-down.service';
import { ActivatedRoute } from '@angular/router';
import { ProjectService } from 'src/app/service/project.service';
import { Project } from 'src/app/model/project.model';
import { NgForm } from '@angular/forms';
import { timer } from 'rxjs';
import { Young } from 'src/app/model/young.model';
import { YoungService } from '../../service/young.service';

@Component({
  selector: 'plm-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.css']
})
export class ProjectComponent implements OnInit {



  public dropDownValues: Object;
  public project: Project;
  public successMessage: string;
  public errorMessage: string;
  public youngs: Young[];
  public accompanyingTypes: Array<any>;
  public commonAccompanyingTypeId: number;
  public projectId:number;

  constructor(private dropDownService: DropDownService,
	private projectService: ProjectService,
	private route: ActivatedRoute,
	private youngService:YoungService) { }

  ngOnInit() {
    this.initDropDownValue();
    this.projectId = this.route.snapshot.params['id'];
    if (this.projectId) {
      this.projectService.getProjectById(this.projectId).subscribe(project => this.project = project);
      this.projectService.getYoungsByProjectId(this.projectId).subscribe((youngs: Young[]) => this.youngs = youngs);
    } else {
      this.project = new Project();
    }
	this.accompanyingTypes = this.youngService.getAccompanyingTypes();
  }



  initDropDownValue() {
    this.dropDownService.getDropDownValues().subscribe((dropDownValues: any) => {
      this.dropDownValues = dropDownValues.reduce(
        (map, dropDownValue) => { map[dropDownValue['key']] = dropDownValue['values']; return map; }, {});
    });
  }

  getDropDownValues(key: string) {
    if (this.dropDownValues) {
      let values = this.dropDownValues[key];
      if (!values) {
        values = [];
      }
      return values;
    }
  }

  saveProject(form: NgForm) {
    console.log(form.valid);
    if (form.valid) {
      this.projectService.saveProject(this.project).subscribe(project => {
        this.project = project;
        this.successMessage = 'Projet enregitré avec succès.';
        timer(3000).subscribe(() => this.successMessage = undefined);
      });
    } else {
      this.errorMessage = 'Des erreurs ont été détecté dans le formulaire.';
      timer(3000).subscribe(() => this.errorMessage = undefined);
    }
  }

  updateYoungsStatus() {
	console.log(this.commonAccompanyingTypeId);
	if(this.commonAccompanyingTypeId) {
		this.youngService.updateYougsStatus(this.youngs, this.commonAccompanyingTypeId).subscribe(
			() =>  this.projectService.getYoungsByProjectId(this.projectId).subscribe((youngs: Young[]) => this.youngs = youngs));
	}
  }
}
